module.exports = __webpack_public_path__ + "img/wedcr1.828dc98a.jpg";